// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QdjW89a4XUVkLxuZWsPk{flex-direction:column;gap:24px;padding:0 24px 16px;display:flex}.lvzFARShKmoNcUSLWfOy{cursor:default;align-items:center;padding:8px 12px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContent": `QdjW89a4XUVkLxuZWsPk`,
	"linkContainer": `lvzFARShKmoNcUSLWfOy`
};
export default ___CSS_LOADER_EXPORT___;
